<nav class="sidebar-nav">
    <ul id="sidebarnav">
        <!-- First level menu -->
        <li class="sidebar-item" [class.active]="showMenu === sidebarnavItem.title" *ngFor="let sidebarnavItem of sidebarnavItems"
            [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'">
            <div class="nav-small-cap" *ngIf="sidebarnavItem.extralink === true"><i [ngClass]="[sidebarnavItem.icon]"></i><span class="hide-menu">{{sidebarnavItem.title}}</span></div>
            <a class="sidebar-link waves-effect waves-dark" [routerLink]="sidebarnavItem.class === '' ? [sidebarnavItem.path] : null"
                [ngClass]="[sidebarnavItem.class]" *ngIf="!sidebarnavItem.extralink;"
               (click)="addExpandClass(sidebarnavItem.title)"
                [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'"  #rla="routerLinkActive">
                <img [ngClass]="[sidebarnavItem.icon]" alt="" class="img-menu" src="{{rla.isActive ? sidebarnavItem.urlhover : sidebarnavItem.url}}" width="25" height="25"/>
              <span class="text-grey" ><i class="fas fa-caret-left caret" *ngIf="rla.isActive"></i></span>
                <span class="hide-menu">{{sidebarnavItem.title}}
                    <span *ngIf="sidebarnavItem.label != '' " [ngClass]="[sidebarnavItem.labelClass]">{{sidebarnavItem.label}}</span>
                </span>
            </a>
        </li>
      <!-- UserModel Profile-->
      <li class="sidebar-item user-profile profile" [class.active]="showMenu === 'user'" *ngIf="user">
        <a class="sidebar-link waves-effect waves-dark" routerLink="/dashboard/profile" [routerLinkActive]="'active'"
            aria-expanded="false" #rla="routerLinkActive">
          <span>
          <img [src]="user.urlphoto" alt="user" *ngIf="user.urlphoto !== null && user.urlphoto !== undefined && user.urlphoto !== ''"/>
          <img src="../../../../assets/images/user_default.png" alt="user" *ngIf="user.urlphoto === null || user.urlphoto === undefined || user.urlphoto === ''"/>
          </span>
          <span class="hide-menu"></span>
        </a>

      <div class="connection-status" [ngClass]="!isConnected ?'back-red': ''">
        <!--<button class="online" id="company_status" >{{status}}</button>-->
      </div>

      </li>
    </ul>
</nav>
